import styled from 'styled-components';

import { theme } from '../../../../global';

export const Label = styled.span`
  position: absolute;
  left: 18px;
  top: 16px;
  font-size: 16px;
  font-weight: 500;
  padding: 2px;
  color: ${theme.colors.textfield_enabled};
  background-color: ${theme.colors.white};
  transition: top 0.1s ease-in-out;
`;

export const Container = styled.label`
  position: relative;

  &:focus-within ${Label} {
    top: -10px;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 52px;
  padding: 18px 12px;
  border-radius: 12px;
  border: 1px solid ${theme.colors.textfield_enabled};
  color: ${theme.colors.textfield_enabled};
  font-weight: 700;

  &::placeholder {
    color: transparent;
  }

  &:not(:placeholder-shown) ~ ${Label} {
    top: -10px;
  }
`;
